module.exports = __webpack_public_path__ + "img/account_balance@2x (2).92ff2ac9.png";